import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/cn";
import { cardInteractiveClasses } from "./Card";

const serviceCardLinkExtras =
  "no-underline visited:text-inherit hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-600 focus-visible:ring-offset-2";

/** Router Link styled as the standard interactive service card surface. */
export function ServiceCardLink({ className, ...props }) {
  return (
    <Link
      className={cn(cardInteractiveClasses, serviceCardLinkExtras, className)}
      {...props}
    />
  );
}
